// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-8da460e4] .ml-1.text-primary.body-2-bold{margin:0;text-indent:-10000px}[data-v-8da460e4] [role=presentation]{align-items:center;display:flex}[data-v-8da460e4] svg{height:12px;width:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
